module.exports = __webpack_public_path__ + "img/favicon-196x196.fed083e8.png";